import React, { useState, useEffect } from "react";
import { Pagination } from "react-bootstrap";
import useSettings from "stores/settings";

const Paginations = ({ items, onChangePage, nowPage }) => {
  const settings = useSettings();
  const [pager, setPager] = useState({});

  useEffect(() => {
    if (nowPage) {
      setPage(nowPage);
    } else {
      setPage(1);
    }

    /* 스크롤 이동 */
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // setPage(1);
  }, [items]);

  const setPage = (page) => {
    var tempItems = items;
    var tempPager = pager;

    if (page < 1 || page > pager.totalPages) {
      return;
    }

    // get new pager object for specified page
    tempPager = getPager(tempItems.length, page, 8, 10);

    // get new page of items from items array
    var pageOfItems = tempItems.slice(tempPager.startIndex, tempPager.endIndex + 1);

    // update state
    setPager(tempPager);
    if (nowPage) {
      settings.aisoMarketPage = page;
    }

    // call change page function in parent component
    onChangePage(pageOfItems, tempPager.startIndex);

    /* 스크롤 이동 */
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getPager = (totalItems, currentPage, pageSize, maxPagesToDisplay) => {
    // default to first page
    currentPage = currentPage || 1;

    // default page size is 10
    pageSize = pageSize || 10;

    // default max pages to display is 10
    maxPagesToDisplay = maxPagesToDisplay || 10;

    // calculate total pages
    var totalPages = Math.ceil(totalItems / pageSize);

    var startPage, endPage;
    if (totalPages <= maxPagesToDisplay) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages

      var halfwayPoint = Math.ceil(maxPagesToDisplay / 2);
      var pastHalfwayPoint = Math.floor(maxPagesToDisplay / 2) + 1;
      var beforeHalfwayPoint = halfwayPoint - 1;
      if (currentPage <= pastHalfwayPoint) {
        startPage = 1;
        endPage = maxPagesToDisplay;
      } else if (currentPage + beforeHalfwayPoint >= totalPages) {
        startPage = totalPages - (maxPagesToDisplay - 1);
        endPage = totalPages;
      } else {
        startPage = currentPage - halfwayPoint;
        endPage = currentPage + beforeHalfwayPoint;
      }
    }

    // calculate start and end item indexes
    var startIndex = (currentPage - 1) * pageSize;
    var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    const pages = [];
    Array.from({ length: endPage + 1 - startPage }, (v, i) => pages.push(startPage + i));

    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages,
    };
  };

  if (!pager.pages || pager.pages.length <= 1) {
    // don't display pager if there is only 1 page
    return null;
  }

  return (
    <Pagination className="rounded-separated pagination-primary justify-center mt-20">
      <Pagination.Prev className={pager.currentPage === 1 ? "disabled" : ""} onClick={() => setPage(pager.currentPage - 1)} />
      {/* <Pagination.Ellipsis /> */}
      {pager.pages.map((page, index) => (
        <li key={index} className={pager.currentPage === page ? "page-item active" : "page-item"} style={{ cursor: "pointer" }}>
          <a className="page-link" onClick={() => setPage(page)}>
            {page}
          </a>
        </li>
      ))}
      <Pagination.Next
        className={pager.currentPage === pager.totalPages ? "disabled" : ""}
        onClick={() => setPage(pager.currentPage + 1)}
      />
    </Pagination>
  );
};

export default Paginations;
